export default {"src":"/_next/static/media/ar_up.18f9f0d6.svg","height":8,"width":14,"blurWidth":0,"blurHeight":0};